import React from 'react';
import {
  compose,
  lifecycle,
  withState,
  withHandlers,
  withProps,
  withPropsOnChange,
} from 'recompose';
import { get, find } from 'lodash';
import { withRouter } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import { Tabs, Tab } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { Grid, Table, TableHeaderRow, TableFilterRow } from '@devexpress/dx-react-grid-material-ui';
import { withSnackbar } from 'notistack';
import {
  SortingState,
  IntegratedSorting,
  DataTypeProvider,
  FilteringState,
  IntegratedFiltering,
} from '@devexpress/dx-react-grid';
import moment from 'moment';

import Add from './add';
import { allServices } from '../services/_api';
import { allItemServices } from './_api';
import withLoader from '../app/withLoader';
import { itemServiceTypes } from '../../utils/constants/index';

const DateFormatter = ({ value }) => moment(value).format('DD.MM.YYYY, HH:mm:ss');

const DateTypeProvider = (props) => (
  <DataTypeProvider formatterComponent={DateFormatter} {...props} />
);

const dateTimePredicate = (value, filter) =>
  moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm:ss').startsWith(filter.value);

const integratedFilteringColumnExtensions = [
  { columnName: 'createdDate', predicate: dateTimePredicate },
  { columnName: 'from', predicate: dateTimePredicate },
  { columnName: 'to', predicate: dateTimePredicate },
];

const enhance = compose(
  withRouter,
  withLoader,
  withSnackbar,
  withState('items', 'setItems', []),
  withState('activeTab', 'setActiveTab', 'new'),
  withState('users', 'setUsers', null),
  withState('services', 'setServices', []),
  withHandlers({
    loadList:
      ({ setItems }) =>
      async () => {
        const resp = await allItemServices();
        setItems(get(resp, 'items', []));
      },
  }),
  withProps(
    ({
      match: {
        params: { category },
      },
    }) => ({
      category,
    })
  ),
  lifecycle({
    async componentDidMount() {
      const {
        loadList,
        setServices,
        match: {
          params: { category },
        },
      } = this.props;
      const services = await allServices();
      setServices(get(services, 'items', []));
      console.log(category);
      if (category === 'list' || !category) {
        loadList();
      }
      this.props.setActiveTab(category || 'list');
    },
  }),
  withPropsOnChange(['category'], ({ setActiveTab, category, loadList }) => {
    setActiveTab(category || 'list');
    if (category === 'list') {
      loadList();
    }
  }),
  withHandlers({
    redirectTo:
      ({ history }) =>
      (id) => {
        history.push(`/item-services/${id}`);
      },
    handleTabChange:
      ({ loadList, setActiveTab, history }) =>
      async (event, value) => {
        setActiveTab(value);
        history.push(`/item-services/${value}`);
        if (value === 'list') {
          loadList();
        }
      },
    TabContainer: () => (props) => {
      return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
          {props.children}
        </Typography>
      );
    },
  }),
  withHandlers({
    TableRow:
      ({ redirectTo }) =>
      ({ row, ...restProps }) =>
        (
          <Table.Row
            {...restProps}
            style={{
              cursor: 'pointer',
              ':hover': { background: '#7eb6e4' },
            }}
            onClick={() => redirectTo(get(row, 'id'))}
          />
        ),
  }),
  withProps(({ setDialog, statusNames, toggleLoader, enqueueSnackbar, activeTab, services }) => {
    return {
      columns: [
        { name: 'id', title: 'ID' },
        {
          name: 'customerName',
          title: 'Zákazník',
        },
        {
          name: 'serviceId',
          title: 'Typ servisu',
          getCellValue: (row) =>
            get(find(itemServiceTypes, { id: get(row, 'itemServiceType') }), 'label', ''),
        },
        { name: 'completionDate', title: 'Do' },
        { name: 'note', title: 'Poznámka' },
        { name: 'price', title: 'Cena', getCellValue: (row) => `${get(row, 'price', 0)} Kč` },
        { name: 'status', title: 'Stav', getCellValue: (row) => 'přijato' },
        { name: 'createdDate', title: 'Vytvořeno' },
      ],
    };
  })
);

export default enhance(
  ({
    items,
    TableRow,
    columns,
    activeTab,
    handleTabChange,
    TabContainer,
    users,
    setItems,
    toggleLoader,
  }) => (
    <div style={{ margin: 10 }}>
      <Tabs value={activeTab} onChange={handleTabChange} scrollButtons="auto">
        <Tab key={'list'} label={'Přehled'} value="list" />
        <Tab key={'new'} label={'Nový'} value="new" />
      </Tabs>
      <TabContainer>
        {activeTab === 'list' ? (
          <Paper>
            <div className="grid--clickable">
              <Grid rows={items} columns={columns}>
                <SortingState defaultSorting={[{ columnName: 'id', direction: 'desc' }]} />
                <DateTypeProvider for={['createdDate', 'completionDate']} />
                <FilteringState defaultFilters={[]} />
                <IntegratedSorting />
                <IntegratedFiltering columnExtensions={integratedFilteringColumnExtensions} />
                <Table rowComponent={TableRow} />
                <TableHeaderRow showSortingControls />
                <TableFilterRow />
              </Grid>
            </div>
          </Paper>
        ) : null}
        {activeTab === 'new' && <Add handleTabChange={handleTabChange} />}
      </TabContainer>
    </div>
  )
);



// WEBPACK FOOTER //
// ./src/modules/item-services/index.js